import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import Modal from 'react-bootstrap/lib/Modal';

class CustomModal extends React.Component {
    onClose = () => {
        if (this.props.onCloseClicked)
            this.props.onCloseClicked();
        this.props.dispatch({ type: 'CLOSE_MODAL' });//always close the modal after click cancel
    }
    onAccept = () => {
        if (this.props.onActionClicked)
            this.props.onActionClicked();
        this.props.dispatch({ type: 'CLOSE_MODAL' });//always close the modal after click accept
    }
    render() {
        const p = this.props;
        return (
            <div>
                <Modal show={p.showModal != null && p.showModal != undefined && p.showModal} onHide={this.onClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{p.headerText}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         <span dangerouslySetInnerHTML={{ __html:p.bodyText }} />                       
                    </Modal.Body>
                    <Modal.Footer>
                        {p.closeButtonText ?
                            <Button className="btn btn-secondaryOSA" onClick={this.onClose}>{p.closeButtonText}</Button>
                            : null}
                        {p.actionButtonText ?
                            <Button className="btn btn-primaryOSA" onClick={this.onAccept}>{p.actionButtonText}</Button>
                            : null}
                    </Modal.Footer>
                </Modal>
            </div>

        );
    }
}

CustomModal.propTypes = {
    headerText: PropTypes.string,
    bodyText: PropTypes.string,
    actionButtonText: PropTypes.string,
    closeButtonText: PropTypes.string,
    onActionClicked: PropTypes.func,
    onCloseClicked: PropTypes.func,
    dispatch: PropTypes.func
};
const mapStateToProps = (state) => {
    return {
        showModal: state.gas.modal
    };
};
export default connect(mapStateToProps)(CustomModal);